import React, { useEffect, useState } from "react";
import CipHeader from "./CipHeader";
import cogoToast from "cogo-toast";
import { withRouter, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DatePicker from "react-datepicker";
import jsPDF from "jspdf";
import moment from "moment";
import "jspdf-autotable";
import formsService from "../services/forms-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import "react-datepicker/dist/react-datepicker.css";

const KopForm = ({ history }) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [titleText, setTitleText] = useState();
  const { kopForm } = useParams();
  const [loading, setLoading] = useState(false);
  const getFormType = async () => {
    if (kopForm === "kop") {
      setTitleText("CREATE KOP FORM");
    } else {
      setTitleText("CREATE RELEASE MEDICATION RECEIPT");
    }
  };
  const onSubmit1 = async (data) => {
    try {
      if (!startDate || !endDate || startDate > endDate) {
        const { hide } = cogoToast.error(
          "Please chose valid start date and end date ",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      } else {
        let date1 = moment(startDate).format("MM-DD-YYYY");
        let date2 = moment(endDate).format("MM-DD-YYYY");
        let formType = "";
        if (kopForm === "kop") {
          formType = "S";
        } else {
          formType = "R";
        }
        setLoading(true);
        let resp = await formsService.getForms(
          moment(startDate).format("YYYY-MM-DD"),
          moment(endDate).format("YYYY-MM-DD"),
          formType
        );
        setLoading(false);
        const doc = new jsPDF("", "", "a3");
        let formtext = "";
        let fileName = "";

        if (kopForm === "kop") {
          formtext = "KOP Medication Administration Record (MAR)";
          fileName = "KOP";
        } else {
          formtext = "Patient-Inmate Release Medication Receipt";
          fileName = "ReleaseMedicationReceipt";
        }
        if (resp?.length) {
          for (let p = 0; p < resp.length; p++) {
            doc.setFontSize(12);
            doc.setFont("helvetica");
            doc.text("Clinical Solutions Pharmacy", 140, 10, "center");
            doc.text(formtext, 140, 15, "center");
            doc.text(
              "Print Date " + date1 + " to " + date2 + "",
              140,
              20,
              "center"
            );
            doc.setFontSize(8);
            doc.text("Facility:", 20, 30);
            doc.text("Patient Name", 55, 30);
            doc.text("ID #:", 100, 30);
            doc.text("DOB:", 140, 30);
            doc.text("Medication:", 180, 30);
            doc.text("Expanded Sig:", 20, 35);
            doc.text("Dr Name:", 20, 40);
            doc.text("Start Date:", 100, 40);
            doc.text("Fill Date", 140, 40);
            doc.text("Expiration Date", 180, 40);
            doc.text("Days Supply", 230, 40);
            doc.text(
              "________________________________________________________________________________________________________________________________________________________________",
              20,
              42
            );

            var top = 45;
            let itemsList = resp[p].items;
            // eslint-disable-next-line no-loop-func
            itemsList.forEach((ele, i) => {
              top = top + 5;
              doc.text(ele.facility, 20, top);
              doc.text(
                ele.patientLastName + " " + ele.patientFirstName,
                55,
                top
              );
              doc.text(ele.patientAccount || "", 100, top);
              doc.text(moment(ele.patientDob).format("MM/DD/YYYY"), 140, top);
              doc.text(
                ele.drugName + " " + ele.drugStrength + " " + ele.drugDosage,
                180,
                top
              );
              top = top + 5;
              doc.text(ele.expandedSig, 20, top);
              top = top + 5;
              doc.text(ele.doctorLastName + " " + ele.doctorFirstName, 20, top);
              doc.text(moment(ele.startDate).format("MM/DD/YYYY"), 100, top);
              doc.text(moment(ele.fillDate).format("MM/DD/YYYY"), 140, top);
              doc.text(moment(ele.expiryDate).format("MM/DD/YYYY"), 180, top);
              doc.text(ele.daysSupply.toString(), 230, top);
              top = top + 10;
              doc.text("Sign    __________________________________", 20, top);
              doc.text("Date    __________________________________", 100, top);
              top = top + 5;
              doc.text(
                "________________________________________________________________________________________________________________________________________________________________",
                20,
                top
              );
              top = top + 5;
            });

            doc.text(
              "Nurse Signature   _____________________________________",
              20,
              top + 5
            );
            if (p !== resp.length - 1) doc.addPage();
          }
          doc.save(fileName + ".pdf");
        } else {
          const { hide } = cogoToast.error("Record Not Found!", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
        }
      }
    } catch (e) {
      const { hide } = cogoToast.error("Record Not Found!", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  };
  useEffect(() => {
    getFormType();
  }, [kopForm]);

  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">{titleText}</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <h1 className="font-semibold text-md mt-5 mb-4 pb-4 border-b">
            INSTRUCTIONS
          </h1>
          <form>
            <ul className="">
              <li className="inline-block text-xs text-menu_txt leading-10 w-full">
                1. Select a Starting and Ending Print Date Range.
              </li>
              <li className="inline-block text-xs leading-10 text-menu_txt w-full">
                2. Click Submit when ready to create form.
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-1/2 mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">Start Date</label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <DatePicker
                  placeholderText="MM/DD/YYYY"
                  selected={startDate}
                  onChange={(date) => {
                    setStartDate(date);
                  }}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                />
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-1/2 mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">End Date</label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <DatePicker
                  placeholderText="MM/DD/YYYY"
                  selected={endDate}
                  onChange={(date) => {
                    setEndDate(date);
                  }}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                />
              </li>
              <li className="inline-block text-sm leading-10 w-full">
                <button
                  onClick={() => {
                    onSubmit1();
                  }}
                  type="button"
                  label="Submit"
                  className="text-white rounded font-semibold text-sm h-10 w-full bg-secondary bg-login_btn mb-3"
                >
                  SUBMIT
                </button>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(KopForm)
);
